/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sol_Operasional_LeadInputs */

const en_mk_sol_operasional_lead = /** @type {(inputs: Mk_Sol_Operasional_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Twenty people keeping daily processes running: billing, reconciliation, reporting, reminders. Small errors here are expensive, and being on time matters more than being fast.`)
};

const id_mk_sol_operasional_lead = /** @type {(inputs: Mk_Sol_Operasional_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dua puluh orang menjaga proses yang berjalan tiap hari: penagihan, rekonsiliasi, laporan, pengingat. Kesalahan kecil di sini mahal, dan ketepatan waktu lebih penting daripada kecepatan.`)
};

/**
* | output |
* | --- |
* | "Twenty people keeping daily processes running: billing, reconciliation, reporting, reminders. Small errors here are expensive, and being on time matters more..." |
*
* @param {Mk_Sol_Operasional_LeadInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sol_operasional_lead = /** @type {((inputs?: Mk_Sol_Operasional_LeadInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sol_Operasional_LeadInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sol_operasional_lead(inputs)
	return en_mk_sol_operasional_lead(inputs)
});